
import React from 'react';

interface ValidationResultProps {
  validationResult: { isValid: boolean; errors: string[] };
}

export const ValidationResult: React.FC<ValidationResultProps> = ({ validationResult }) => {
  return (
    <div className={`p-4 rounded ${validationResult.isValid ? 'bg-green-100 dark:bg-green-900' : 'bg-red-100 dark:bg-red-900'}`}>
      {validationResult.isValid ? (
        <p className="text-green-700 dark:text-green-300">Template is valid!</p>
      ) : (
        <div>
          <p className="text-red-700 dark:text-red-300 font-bold">Template validation failed:</p>
          <ul className="list-disc pl-5">
            {validationResult.errors.map((error, index) => (
              <li key={index} className="text-red-600 dark:text-red-300">{error}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
